module.exports = __webpack_public_path__ + "img/student-tip.a92c619b.png";